import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiEdit3,FiMail,FiSmartphone,FiGlobe,FiSearch,FiTarget,FiVideo,FiCheck,FiStar}=FiIcons;

function Services() {
  const services=[ 
    {icon: FiEdit3,title: 'AI Blog Content (Pro Edition)',description: 'Build long-term trust and search visibility with helpful,localized written content that gets read and ranks.',included: [ 
      'Strategic topic selection with local keywords',
      'AI-generated first drafts with human polish',
      'SEO optimization for better rankings',
      'Local relevance and client examples',
      'Delivered in clean,ready-to-publish format' 
    ],process: [ 
      'Choose strategic local keywords',
      'Generate structured first draft',
      'Humanize and improve writing',
      'Add SEO optimization',
      'Deliver polished content' 
    ]},
    {icon: FiMail,title: 'Email Marketing (Pro Edition)',description: 'Nurture leads,build trust,and turn attention into action with strategic email campaigns.',included: [ 
      'Monthly strategy planning',
      'Story-based value emails',
      'Automated nurturing sequences',
      'Subject line optimization',
      'Performance tracking and optimization' 
    ],process: [ 
      'Define monthly email strategy',
      'Plan email flow and sequence',
      'Create compelling content',
      'Optimize subject lines and CTAs',
      'Format and deliver campaigns' 
    ]},
    {icon: FiSmartphone,title: 'Social Media Posts (5 Per Month)',description: 'Build daily familiarity and trust with local audiences using short-form content.',included: [ 
      '10 proven post formats',
      'Local tips and myth-busting',
      'Behind-the-scenes content',
      'Client success stories',
      'Seasonal reminders and offers' 
    ],process: [ 
      'Select 5 post types from proven formats',
      'Create engaging,educational content',
      'Optimize for local audience',
      'Include suggested image ideas',
      'Deliver formatted posts' 
    ]},
    {icon: FiGlobe,title: 'Website Copy',description: 'Create conversion-friendly web pages that clearly explain services and build credibility.',included: [ 
      'Homepage optimization',
      'Service page creation',
      'About page development',
      'Clear value propositions',
      'Strong calls-to-action' 
    ],process: [ 
      'Analyze current website needs',
      'Develop compelling copy',
      'Focus on conversion optimization',
      'Ensure brand consistency',
      'Deliver formatted content' 
    ]},
    {icon: FiSearch,title: 'Local SEO Pages (Advanced SEO + GEO Edition)',description: 'Create long-form,localized pages that help clients dominate search results.',included: [ 
      'High-converting local keywords',
      'Advanced SEO optimization',
      'Generative Engine Optimization (GEO)',
      'Local area coverage',
      'Schema-ready content' 
    ],process: [ 
      'Research buyer-intent local keywords',
      'Generate comprehensive content',
      'Optimize for SEO and GEO',
      'Add local relevance and links',
      'Deliver publication-ready pages' 
    ]},
    {icon: FiTarget,title: 'Lead Magnet Writing',description: 'Create downloadable guides or checklists that help collect emails and position clients as experts.',included: [ 
      'Topic tied to top services',
      '1,000+ word comprehensive guides',
      'Skimmable section format',
      'Professional design ready',
      'Light CTA integration' 
    ],process: [ 
      'Select strategic topic',
      'Create comprehensive guide',
      'Format for easy reading',
      'Design in Canva',
      'Deliver PDF and source files' 
    ]},
    {icon: FiVideo,title: 'YouTube Script Writing (Bento Box Formula)',description: 'Write powerful 8-12 minute scripts that position clients as go-to experts and drive bookings.',included: [ 
      'Strategic topic selection',
      'Powerful hook formulas',
      'Bento box content structure',
      'Clear call-to-action',
      'Speaker notes and timestamps' 
    ],process: [ 
      'Choose high-impact topics',
      'Craft compelling hooks',
      'Structure with bento box method',
      'Include strong CTAs',
      'Format with visual cues' 
    ]} 
  ];

  const packages=[ 
    {name: 'Starter',description: 'Perfect for small local businesses just starting with content marketing',features: [ 
      '2 Blog Posts per month',
      'Basic SEO optimization',
      'Quarterly strategy calls',
      'Monthly performance reports',
      'Email support' 
    ],popular: false},
    {name: 'Growth',description: 'Ideal for growing businesses ready to scale their marketing efforts',features: [ 
      '4 Blog Posts + Social Media',
      'Monthly Newsletter',
      'Advanced SEO optimization',
      '1 Lead Magnet per quarter',
      'Monthly strategy calls',
      'Priority support' 
    ],popular: true},
    {name: 'Pro',description: 'Comprehensive marketing for established businesses seeking maximum growth',features: [ 
      'Weekly Blog + YouTube + Social',
      'Weekly Email Campaigns',
      'Comprehensive SEO + GEO',
      'Monthly Lead Magnets',
      'Bi-weekly strategy calls',
      'Dedicated account manager' 
    ],popular: false} 
  ];

  return ( 
    <div> 
      {/* Services Hero */} 
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 py-20"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6"> 
            Our Services 
          </h1> 
          <p className="text-xl text-blue-100 max-w-3xl mx-auto"> 
            Everything you need to grow your local business,delivered as done-for-you solutions. 
          </p> 
        </div> 
      </section> 

      {/* Detailed Services */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="space-y-16"> 
            {services.map((service,index)=> ( 
              <div key={index} className="bg-gray-50 rounded-2xl p-8 lg:p-12"> 
                <div className="grid lg:grid-cols-2 gap-12 items-start"> 
                  <div> 
                    <div className="flex items-center space-x-4 mb-6"> 
                      <div className="p-3 bg-blue-100 rounded-xl"> 
                        <SafeIcon icon={service.icon} className="h-8 w-8 text-blue-600" /> 
                      </div> 
                      <h2 className="text-2xl lg:text-3xl font-bold text-gray-900">{service.title}</h2> 
                    </div> 
                    <p className="text-lg text-gray-600 mb-8">{service.description}</p> 
                    <div className="mb-8"> 
                      <h3 className="text-xl font-semibold text-gray-900 mb-4">What's Included:</h3> 
                      <ul className="space-y-3"> 
                        {service.included.map((item,idx)=> ( 
                          <li key={idx} className="flex items-start space-x-3"> 
                            <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                            <span className="text-gray-700">{item}</span> 
                          </li> 
                        ))} 
                      </ul> 
                    </div> 
                  </div> 
                  <div className="bg-white rounded-xl p-6 shadow-lg"> 
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Process:</h3> 
                    <ol className="space-y-3"> 
                      {service.process.map((step,idx)=> ( 
                        <li key={idx} className="flex items-start space-x-3"> 
                          <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-medium"> 
                            {idx + 1} 
                          </span> 
                          <span className="text-gray-700">{step}</span> 
                        </li> 
                      ))} 
                    </ol> 
                  </div> 
                </div> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Service Packages */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Service Packages 
            </h2> 
            <p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
              Choose the package that best fits your business needs. Contact us for custom pricing based on your specific requirements. 
            </p> 
          </div> 
          <div className="grid md:grid-cols-3 gap-8"> 
            {packages.map((pkg,index)=> ( 
              <div key={index} className={`bg-white rounded-xl p-8 shadow-lg relative ${pkg.popular ? 'ring-2 ring-blue-600' : ''}`}> 
                {pkg.popular && ( 
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2"> 
                    <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium flex items-center space-x-1"> 
                      <SafeIcon icon={FiStar} className="h-4 w-4" /> 
                      <span>Most Popular</span> 
                    </span> 
                  </div> 
                )} 
                <div className="text-center mb-8"> 
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3> 
                  <p className="text-gray-600">{pkg.description}</p> 
                </div> 
                <ul className="space-y-4 mb-8"> 
                  {pkg.features.map((feature,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{feature}</span> 
                    </li> 
                  ))} 
                </ul> 
                <Link 
                  to="/book-consultation" 
                  className={`block w-full text-center py-3 px-6 rounded-lg font-semibold transition-colors ${
                    pkg.popular 
                      ? 'bg-blue-600 text-white hover:bg-blue-700' 
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`} 
                > 
                  Schedule Your Free Consultation 
                </Link> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* CTA Section */} 
      <section className="py-16 bg-blue-900"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6"> 
            Ready to Get Started? 
          </h2> 
          <p className="text-xl text-blue-100 mb-10 max-w-3xl mx-auto"> 
            Let's discuss which services and package would work best for your business goals. 
          </p> 
          <Link 
            to="/book-consultation" 
            className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors" 
          > 
            Schedule Your Free Consultation 
          </Link> 
        </div> 
      </section> 
    </div> 
  );
}

export default Services;